"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  'new south wales': 'nsw',
  'northern territory': 'nt',
  'queensland': 'qld',
  'south australia': 'sa',
  'tasmania': 'tas',
  'victoria': 'vic',
  'western australia': 'wa'
};
exports.default = _default;
//# sourceMappingURL=states_AU_map.js.map